/* global gtag */
import * as React from "react";
import { useState, useRef, useEffect, lazy } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  checkExisting,
  setActionType,
  setGeneratedNeedId,
  setIsChatModalOpen,
  setIsZoomStarted,
  setLink,
  setInquiryNeedOpen,
  setShowCallDialog,
} from "../../../../redux/slices/SearchBarSlice";
import {
  resetFormState,
  setAlternativePhoneOne,
  setDescription,
  setEmail,
  setPhone,
  setZipcode,
} from "../../../../redux/slices/RequestFormSlice";
import {
  setDropdownOpen,
  setIsModalOpen,
} from "../../../../redux/slices/bwvSlice";
import { userAction } from "../../../../redux/slices/userSlice";
import { useNavigate, useLocation } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { countryCodes } from "../../../CountryCodes";
import { toast } from "react-toastify";
import { getAllMessages, sendMessage } from "../../Data";
import { useSocket } from "../../../../contexts/SocketContext";
import axiosClient from "../../../../axios-client";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import NeedInquiryForm from "./NeedInquiryForm";
import NeedInquiryOtp from "./NeedInquiryOtp";
import { FaWindowClose } from "react-icons/fa";

// Lazy-load utilities
const loadUtilities = async () => {
  const { default: axiosClient } = await import("../../../../axios-client");
  const {
    makeCall,
    postRequest,
    sendMsgMail,
    virtualTourClick,
    postOtherVendors,
  } = await import("../../Data");
  const { GetZoomLink } = await import("../../Data2");
  return {
    axiosClient,
    makeCall,
    postRequest,
    postOtherVendors,
    sendMsgMail,
    virtualTourClick,
    GetZoomLink,
    toast,
  };
};

// Debounce utility
const debounce = (func, wait) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
};

const NeedInquiryModal = () => {
  const { selectedConvo } = useSelector((state) => state.messages);
  const islogin = useSelector((state) => state.user.isLogin);
  const userData = useSelector(
    (state) => state.user.userDetails.profileDetails
  );
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const {
    inquiryNeedOpen,
    sampleAd,
    actionType,
    checkExistingError,
    checkExistingStatus,
    vTName,
    vTNumber,
    answers,
  } = useSelector((state) => state.searchBar);
  const { sendNewMessage } = useSocket();
  const { searchQuery } = useSelector((state) => state.lcAds);
  const dispatch = useDispatch();
  const formData = useSelector((state) => state.requestForm);
  const [isLoading, setIsLoading] = useState(false);
  // const [descriptionError, setDescriptionError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [secondaryPhoneError, setSecondaryPhoneError] = useState(false);
  const [zipcodeError, setZipcodeError] = useState(false);
  const [countryCodeError, setCountryCodeError] = useState(false);
  const [receivedOtp, setReceivedOtp] = useState(null);
  const isProd = process.env.REACT_APP_PRODUCTION === "true";
  const firstInputRef = useRef(null);
  const [step, setStep] = useState(1);
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState("+1");
  const isAdmin = user && user.Role === "admin";
  const isVendor = user?.Role === "provider";
  // Load form data from localStorage when the dialog opens
  useEffect(() => {
    if (inquiryNeedOpen) {
      setStep(1);
      setOtp("");
      setReceivedOtp(null);
      setOtpError(false);
      setSelectedCountry("+1");
      setCountryCodeError(false);
      dispatch(setShowCallDialog(false));
      dispatch(setPhone(""));
      // Load form data from localStorage if available
      const savedFormData = localStorage.getItem("InquiryNeedFormData");
      if (savedFormData) {
        try {
          const parsedFormData = JSON.parse(savedFormData);
          if (islogin) {
            dispatch(setEmail(user?.Email || parsedFormData.Email || ""));
            dispatch(setPhone(user?.Phone || parsedFormData.Phone || ""));
            dispatch(
              setAlternativePhoneOne(
                user?.secondaryPhone ||
                  userData?.secondaryPhone ||
                  parsedFormData.alternativePhoneOne ||
                  ""
              )
            );
            dispatch(setZipcode(user?.ZipCode || parsedFormData.Zipcode || ""));
            dispatch(setDescription(parsedFormData.Description || ""));
            setSelectedCountry(
              user?.CountryCode || parsedFormData.countryCode || "+1"
            );
          } else {
            // For non-logged-in users, set all fields from parsedFormData
            dispatch(setEmail(parsedFormData.Email || ""));
            dispatch(setPhone(parsedFormData.Phone || ""));
            dispatch(
              setAlternativePhoneOne(parsedFormData.alternativePhoneOne || "")
            );
            dispatch(setZipcode(parsedFormData.Zipcode || ""));
            dispatch(setDescription(parsedFormData.Description || ""));
            setSelectedCountry(parsedFormData.countryCode || "+1");
          }
        } catch (error) {
          console.error("Error parsing savedFormData:", error);
        }
      } else if (islogin) {
        // If no saved data, set defaults for logged-in users
        dispatch(setEmail(user?.Email || ""));
        dispatch(setPhone(user?.Phone || ""));
        dispatch(
          setAlternativePhoneOne(
            user?.secondaryPhone || userData?.secondaryPhone || ""
          )
        );
        dispatch(setZipcode(user?.ZipCode || ""));
        dispatch(setDescription(""));
        setSelectedCountry(user?.CountryCode || "+1");
      }
    }
  }, [inquiryNeedOpen]);
  const handleClose = () => {
    dispatch(setInquiryNeedOpen(false));
    dispatch(setDescription(""));
    // setDescriptionError(false);
    setEmailError(false);
    setPhoneError(false);
    setSecondaryPhoneError(false);
    setZipcodeError(false);
    setCountryCodeError(false);
    setOtpError(false);
    setStep(1);
    dispatch(setShowCallDialog(false));
  };
  const validateForm = () => {
    let isValid = true;

    if (!islogin && !formData.Email) {
      setEmailError(true);
      toast.error("Email is required");
      isValid = false;
    }
    if (!formData.Zipcode || !/^\d{5}$/.test(formData.Zipcode)) {
      setZipcodeError(true);
      toast.error("Valid 5-digit zipcode is required");
      isValid = false;
    }
    if (!formData.Phone || formData.Phone.length !== 10) {
      setPhoneError(true);
      toast.error("Valid 10-digit phone number is required");
      isValid = false;
    }
    if (
      !formData.alternativePhoneOne ||
      formData.alternativePhoneOne.length !== 10
    ) {
      setSecondaryPhoneError(true);
      toast.error("Valid 10-digit secondary phone number is required");
      isValid = false;
    }
    if (formData.alternativePhoneOne === formData.Phone) {
      setSecondaryPhoneError(true);
      toast.error(
        "Secondary phone number should be different from primary phone number"
      );
      isValid = false;
    }
    if (!selectedCountry) {
      setCountryCodeError(true);
      toast.error("Please select a country code");
      isValid = false;
    }
    if (!formData?.Description || formData?.Description.trim() === "") {
      // setDescriptionError(true);
      toast.error("Description is required");
      isValid = false;
    }
    return isValid;
  };
  useEffect(() => {
    if (inquiryNeedOpen && firstInputRef.current) {
      firstInputRef.current.focus();
    }
  }, [inquiryNeedOpen, step]);
  const handleBackdropClick = (event) => {
    event.stopPropagation();
  };
  useEffect(() => {
    if (checkExistingStatus === "failed" && checkExistingError) {
      toast.error(checkExistingError);
    }
  }, [checkExistingStatus, checkExistingError]);
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}`;
  };
  const handleSendOtp = async () => {
    const { axiosClient, toast } = await loadUtilities();
    if (!validateForm()) return;
    if (isLoading) return;
    setIsLoading(true);
    try {
      const userData = {
        email: formData.Email,
        Phone: formData.Phone,
        country_code: selectedCountry,
        action: "SIGNUP",
      };
      const response = await axiosClient.post("otp/SendOtp", userData);
      console.log("Send OTP response:", response.data);
      if (response.data.statusCode === 200 && response.data.data?.otp) {
        setReceivedOtp(String(response.data.data.otp));
        toast.success(`Code sent to Phone ${formData.Phone}`);
        setStep(2);
      } else {
        console.error("Invalid OTP response:", response.data);
        toast.error(response.data.message || "Failed to send OTP");
      }
    } catch (error) {
      console.error("Error during OTP sending:", error);
      toast.error("Error sending OTP");
    } finally {
      setIsLoading(false);
    }
  };
  const handleVerifyOtp = async (e) => {
    const { toast } = await loadUtilities();
    e.preventDefault();
    if (!otp || otp.length !== 4) {
      setOtpError(true);
      toast.error("Please enter a 4-digit OTP");
      return;
    }
    if (isLoading) return;
    setIsLoading(true);
    try {
      console.log("Verifying OTP:", {
        otp,
        receivedOtp,
        types: { otp: typeof otp, receivedOtp: typeof receivedOtp },
      });
      // if (otp === receivedOtp || otp === "9999") {
      if (otp === receivedOtp) {
        toast.success("OTP verified successfully");
        await proceedResults();
      } else {
        setOtpError(true);
        toast.error("Invalid OTP");
      }
    } catch (error) {
      console.error("Error during OTP verification:", error);
      setOtpError(true);
      toast.error("Error verifying OTP");
    } finally {
      setIsLoading(false);
    }
  };
  const debouncedSetOtp = debounce((value) => {
    setOtp(value);
    console.log("Debounced OTP set:", value);
  }, 100);
  const handleOtpChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 4);
    console.log("Raw input value:", value);
    debouncedSetOtp(value);
    setOtpError(false);
  };
  useEffect(() => {
    if (otp.length === 4) {
      handleVerifyOtp({ preventDefault: () => {} });
    }
  }, [otp]);
  const MessageSend = async (
    parent,
    userId,
    fullName,
    createdEmail,
    userRole
  ) => {
    const description = formData.Description;
    const messageForm = {
      customerId: sampleAd?.createdBy || "0",
      postId: sampleAd?.Id || "0",
      postType: 1,
      Description: description,
      messageStatus: 8,
      createdBy: userId, // Use updated userId
      roleId: userRole, // Use role from login response if needed
      ownerId: sampleAd?.createdBy || "0",
      userName: fullName, // Use first name from fullName
      Email: createdEmail,
      serviceNeed: "need",
      parentId: !selectedConvo
        ? parent
          ? parent.Id
          : 0
        : selectedConvo.parentId === 0
        ? selectedConvo.Id
        : selectedConvo.parentId ?? 0,
      //   parentId:
      //     selectedConvo?.parentId === 0
      //       ? selectedConvo?.Id ?? 0
      //       : selectedConvo?.parentId ?? 0,
    };
    try {
      const response = await sendMessage(messageForm);
      if (response) {
        sendNewMessage(response.Data);
      }
    } catch (error) {
      console.error("Failed to send message:", error);
      throw error;
    }
  };
  const reset = () => {
    dispatch(setDescription(""));
    dispatch(resetFormState());
    // setDescriptionError(false);
    setEmailError(false);
    setPhoneError(false);
    setSecondaryPhoneError(false);
    setZipcodeError(false);
    setCountryCodeError(false);
    setOtpError(false);
    dispatch(setActionType(null));
    setStep(1);
  };
  const proceedResults = async () => {
    const { toast, postRequest, postOtherVendors } = await loadUtilities();
    if (!validateForm()) return;
    dispatch(setInquiryNeedOpen(false));
    // Initialize userId and userData for logged-in or newly logged-in users
    let userId = user?.UserID || null;
    let fullName = islogin
      ? `${user?.FirstName} ${user?.LastName || ""}`
      : formData?.Email.split("@")[0].trim();
    let createdEmail = user?.Email || formData?.Email;
    let phone = user?.Phone || formData.Phone || null;
    let countryCode = islogin ? user?.CountryCode : selectedCountry;
    let userRole = islogin ? user?.RoleId : 2;
    // Handle login for non-logged-in users
    if (!islogin) {
      try {
        const response = await axiosClient.post("auth/login", {
          email: formData?.Email,
          password: null,
          ssologin: true,
        });
        if (response.data.statusCode === 200) {
          dispatch(
            userAction.setLoginInfo({
              token: response.data.token,
              userInfo: response.data.user,
            })
          );
          localStorage.setItem("USER_ROLE", response.data?.user.Role);
          // Update userId and other user-related data from the login response
          userId = response.data.user.UserID;
          fullName = `${response.data.user.FirstName} ${
            response.data.user.LastName || ""
          }`;
          createdEmail = response.data.user.Email;
          phone = response.data.user.Phone;
          countryCode = response.data.user.CountryCode;
        } else {
          console.error("Login failed:", response.data);
          toast.error(response.data.message || "Login failed");
          return;
        }
      } catch (error) {
        console.error("Error during login:", error);
        toast.error("User does not exist, please register first", {
          theme: "colored",
        });
        return;
      }
    }

    const updatedFormData = {
      ...formData,
      createdBy: userId,
      FullName: fullName,
      ...(formData.availableFrom &&
        typeof formData.availableFrom !== "string" && {
          availableFrom: JSON.stringify(formData.availableFrom),
        }),
      Title: (sampleAd?.Title || searchQuery || "") + " (Auto Generated)",
      Description: formData?.Description + " (Auto Generated Description)",
      categoryId: sampleAd?.categoryId || null,
      subCategoryId: sampleAd?.subCategoryId || null,
      itemId: sampleAd?.itemId || null,
      needRadius: user?.Radius || null,
      Zipcode: user?.ZipCode || formData.Zipcode || "",
      Phone: phone,
      createdEmail: createdEmail,
      vendorId: sampleAd?.createdBy || 0,
      needType: sampleAd ? 1 : null,
      countryCode: countryCode,
    };

    if (
      updatedFormData.availableFrom &&
      typeof updatedFormData.availableFrom !== "string"
    ) {
      updatedFormData.availableFrom = JSON.stringify(
        updatedFormData.availableFrom
      );
    }
    const actionRequired = async () => {
      if (actionType === "CALL") {
        dispatch(setShowCallDialog(true));
      } else if (actionType === "TEXT") {
        dispatch(setIsChatModalOpen(true));
      } else if (actionType === "VISIT") {
        window.open(sampleAd.websiteLink, "_blank");
      } else if (actionType === "HIRE") {
        dispatch(setIsModalOpen(true));
        dispatch(setActionType(null));
      }
    };
    let needExists = false;
    if (islogin || userId) {
      const checkForm = {
        Title: updatedFormData.Title + " (Auto Generated)",
        userId: userId,
      };
      const result = await dispatch(checkExisting(checkForm)).unwrap();
      needExists = result.data;
    }

    if (needExists) {
      dispatch(setGeneratedNeedId(sampleAd?.Id));
      reset();
      return;
    }

    if (isLoading) return;
    setIsLoading(true);
    try {
      await postRequest(updatedFormData);
      actionRequired();
      const formDataToSave = {
        ...formData,
        countryCode: selectedCountry,
      };
      localStorage.setItem(
        "InquiryNeedFormData",
        JSON.stringify(formDataToSave)
      );
      toast.success(
        `Inquiry sent successfully for ${
          sampleAd?.Title || sampleAd?.listName || ""
        }`
      );
      console.log(window.dataLayer, " window.dataLayer");
      if (isProd && window.dataLayer) {
        window.dataLayer.push({
          event: "inquiry_sent",
          method: "inquiry_submission",
          ad_id: sampleAd?.id || sampleAd?.Id,
        });
      }
      if (sampleAd?.createdBy) {
        const req = {
          customerId: +sampleAd?.createdBy,
          needId: sampleAd?.Id || sampleAd?.id,
          createdBy: userId, // Use updated userId
        };
        const response = await getAllMessages(req);
        const filterParent = response.filter((msg) => msg.parentId == 0);
        await MessageSend(
          filterParent[0],
          userId,
          fullName,
          createdEmail,
          userRole
        );
      }
      dispatch(setGeneratedNeedId(sampleAd?.Id));
      dispatch(setInquiryNeedOpen(false));
      reset();
    } catch (error) {
      console.error("Post request error:", error);
      reset();
    } finally {
      setIsLoading(false);
    }
  };
  const handleBack = () => {
    setStep(1);
    setOtp("");
    setOtpError(false);
  };
  if (isAdmin || isVendor) return null;
  return (
    <React.Fragment>
      <Dialog
        open={inquiryNeedOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        PaperProps={{
          style: {
            maxWidth: `600px`,
            zIndex: 1085,
          },
        }}
        sx={{ zIndex: 1085 }}
        BackdropProps={{
          onClick: handleBackdropClick,
          style: { zIndex: 1085 },
        }}
      >
        <Button
          onClick={handleClose}
          style={{
            position: "absolute",
            top: 10,
            right: 10,
            zIndex: 1,
          }}
          aria-label="close"
        >
          <FaWindowClose />
        </Button>
        <DialogTitle id="alert-dialog-title">
          {step === 1
            ? "Please provide details on what you are seeking"
            : "Enter OTP"}
        </DialogTitle>
        <DialogContent>
          {step === 1 && (
            <NeedInquiryForm
              islogin={islogin}
              formData={formData}
              dispatch={dispatch}
              firstInputRef={firstInputRef}
              selectedCountry={selectedCountry}
              setSelectedCountry={setSelectedCountry}
              emailError={emailError}
              setEmailError={setEmailError}
              zipcodeError={zipcodeError}
              setZipcodeError={setZipcodeError}
              phoneError={phoneError}
              setPhoneError={setPhoneError}
              secondaryPhoneError={secondaryPhoneError}
              setSecondaryPhoneError={setSecondaryPhoneError}
              countryCodeError={countryCodeError}
              setCountryCodeError={setCountryCodeError}
              // descriptionError={descriptionError}
              // setDescriptionError={setDescriptionError}
            />
          )}
          {step === 2 && (
            <NeedInquiryOtp
              firstInputRef={firstInputRef}
              otp={otp}
              handleOtpChange={handleOtpChange}
              otpError={otpError}
              handleBack={handleBack}
            />
          )}
        </DialogContent>
        <DialogActions>
          {step === 1 && (
            <Button
              onClick={islogin ? proceedResults : handleSendOtp}
              autoFocus
              disabled={isLoading}
            >
              {isLoading ? (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : islogin ? (
                "Send Inquiry and Proceed"
              ) : (
                "Verify with OTP"
              )}
            </Button>
          )}
          {/* {step === 2 && (
            <Button
              onClick={handleVerifyOtp}
              autoFocus
              disabled={isLoading || otp.length !== 4}
            >
              {isLoading ? (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                " Submit OTP"
              )}
            </Button>
          )} */}
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default NeedInquiryModal;
